import {
  AssetsFixedIncomeControl,
  AssetsFundsControl,
} from '../../../../../store/ProducManagement/types';

import { WithProductId } from '.';

export interface ProductFieldProps<T> {
  key: keyof T;
  label: string;
}

interface ProductDetailsParams {
  productId: number;
  managerImage: string;
  productName: string;
}

export const messageError = '--';

export const getParamsDetailsPerProducts = <T extends WithProductId>(
  item: T,
  productType: 'funds' | 'fixedIncome'
): ProductDetailsParams => {
  switch (productType) {
    case 'funds': {
      const productItem = item as unknown as AssetsFundsControl;
      return {
        productId: Number(productItem.productId),
        managerImage: productItem.managerImage,
        productName: productItem.fundName || '',
      };
    }
    case 'fixedIncome': {
      const productItem = item as unknown as AssetsFixedIncomeControl;
      return {
        productId: Number(productItem.productId),
        managerImage: productItem.managerImage,
        productName: productItem.fixedIncomeIssuerName || '',
      };
    }
    default: {
      return {
        productId: Number(item.productId),
        managerImage: '',
        productName: '',
      };
    }
  }
};
